import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HelperService } from 'app/helpers/helper.service';
import { PostService } from 'app/helpers/post.service';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';



@Component({
  selector: 'app-addbooth-form',
  templateUrl: './addbooth-form.component.html',
  styleUrls: ['./addbooth-form.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class AddboothFormComponent implements OnInit {
  submitted = false;
  registerForm: FormGroup;
  parameters: any;

  form = new FormGroup({
    booth: new FormControl("", Validators.required),
    area: new FormControl("", Validators.required),
    booth_number: new FormControl("", Validators.required),
    total_voters: new FormControl("", Validators.required),
  });
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialog_param: any,
    public matDialogRef: MatDialogRef<AddboothFormComponent>,
    private _activatedRoute: ActivatedRoute,
    private helper: HelperService,
    private postService: PostService,
    private translateService: TranslateService,
    private snackBar: MatSnackBar,


  ) { }

  ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe((data) => {
      this.parameters = this.helper.getParameters(data["_v"]);
  });
  }

  submit() {
    
    var myJson = this.form.value;
    myJson.const_id = this.parameters.const_id;

    this.postService.post(environment.ADD_BOOTH, myJson).subscribe(val => {
      if (val.status == "success") {
            this.translateService
              .get("Booth added successfully.")
              .subscribe((val) => {
                this.snackBar.open(val, "Close!", {
                  panelClass: "snack-success",
                  duration: 5000,
                });
              });
            this.matDialogRef.close(val);
          }
    })
    

  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }

    // display form values on success
    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value, null, 4));
  }

}
